module.exports = __webpack_public_path__ + "static/img/2.b180a29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/2.png
// module id = 8Fsx
// module chunks = 0